export let ApprovalMethodTypeDTO = /*#__PURE__*/function (ApprovalMethodTypeDTO) {
  ApprovalMethodTypeDTO["Manual"] = "manual";
  ApprovalMethodTypeDTO["Automatic"] = "auto";
  return ApprovalMethodTypeDTO;
}({});